<template>
  <div id="printable" class="register-container">
    <!-- Header -->
    <div class="header">
      <div class="facility-name">
        TUURU COTTOLENGO HEALTH CENTRE - AR2026259
      </div>
      <div class="facility-details">
        <div>Igembe Central</div>
        <div>P.O BOX 77 - Meru | Tel: 254254746758069</div>
        <div>Email: suore.tuuru@cottolengo.org</div>
      </div>
      <div class="register-title">MOH 301 - IN-PATIENT REGISTER</div>
    </div>

    <!-- Date Range and Generated By Bar -->
    <div class="info-bar">
      <div class="info-left">
        <div class="date-range">
          <div class="info-item">
            <span class="info-label">From:</span>
            <input
              type="date"
              v-model="dateFrom"
              class="date-input"
              @change="filterPatients"
            />
          </div>
          <div class="info-item">
            <span class="info-label">To:</span>
            <input
              type="date"
              v-model="dateTo"
              class="date-input"
              @change="filterPatients"
            />
          </div>
          <button @click="clearDates" class="btn-clear">Clear</button>
        </div>
        <div class="info-item">
          <span class="info-label">Generated By:</span>
          <span class="info-value">{{ generatedBy }}</span>
        </div>
      </div>
      <button @click="printPage" class="btn-print">🖨️ Print Register</button>
    </div>

    <!-- Date Range Display for Print -->
    <div class="print-date-range">
      <strong>Report Period:</strong> {{ formattedDateFrom }} to
      {{ formattedDateTo }}
    </div>

    <!-- Summary Counts -->
    <div class="summary-counts">
      <div class="count-card">
        <span class="count-label">New Patients</span>
        <div class="count-values">
          <span class="count-item"
            >Male: <strong>{{ newPatientsMale }}</strong></span
          >
          <span class="count-item"
            >Female: <strong>{{ newPatientsFemale }}</strong></span
          >
        </div>
      </div>
      <div class="count-card">
        <span class="count-label">Re-Attendants</span>
        <div class="count-values">
          <span class="count-item"
            >Male: <strong>{{ reAttendantsMale }}</strong></span
          >
          <span class="count-item"
            >Female: <strong>{{ reAttendantsFemale }}</strong></span
          >
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <table class="register-table">
        <thead>
          <tr>
            <th rowspan="2">#</th>
            <th rowspan="2">Date of Admission</th>
            <th rowspan="2">ODP No</th>
            <th rowspan="2">Full Names</th>
            <th rowspan="2">Age (yrs)</th>
            <th colspan="2">Sex</th>
            <th rowspan="2">SubLocation</th>
            <th rowspan="2">Village/Estate</th>
            <th rowspan="2">Address</th>
            <th rowspan="2">HIV(1=counselled, 2=tested)</th>
            <th rowspan="2">HIV(Pos/Neg)</th>
            <th rowspan="2">Nutrition (3=education, 4=supplements)</th>
            <th rowspan="2">Diagnosis</th>
            <th rowspan="2">Treatment/prescription number</th>
            <th rowspan="2">Date of Discharge</th>
            <th rowspan="2">Outcome (A=Alive, D=Dead)</th>
            <th rowspan="2">Referral</th>
            <th rowspan="2">Remarks</th>
          </tr>
          <tr class="sub-header">
            <th>Male</th>
            <th>Female</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(patient, index) in filteredPatients" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ patient.admissionDate }}</td>
            <td>{{ patient.odpNo }}</td>
            <td>{{ patient.fullNames }}</td>
            <td>{{ patient.age }}</td>
            <td class="text-center">
              <span v-if="patient.sex === 'M'">✓</span>
              <span v-else></span>
            </td>
            <td class="text-center">
              <span v-if="patient.sex === 'F'">✓</span>
              <span v-else></span>
            </td>
            <td>{{ patient.subLocation }}</td>
            <td>{{ patient.village }}</td>
            <td>{{ patient.address }}</td>
            <td>{{ patient.hivStatus }}</td>
            <td>{{ patient.hivResult }}</td>
            <td>{{ patient.nutrition }}</td>
            <td>{{ patient.diagnosis }}</td>
            <td>{{ patient.treatmentNo }}</td>
            <td>{{ patient.dischargeDate }}</td>
            <td class="text-center">
              <span
                :class="{
                  'outcome-alive': patient.outcome === 'A',
                  'outcome-dead': patient.outcome === 'D',
                }"
              >
                {{
                  patient.outcome === "A"
                    ? "A"
                    : patient.outcome === "D"
                    ? "D"
                    : ""
                }}
              </span>
            </td>
            <td>{{ patient.referral }}</td>
            <td>{{ patient.remarks }}</td>
          </tr>
          <tr v-if="filteredPatients.length === 0">
            <td colspan="19" class="empty-row">
              No records found for the selected date range
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MOH301Inpatient",
  data() {
    return {
      dateFrom: "2026-04-22",
      dateTo: "2026-04-22",
      generatedBy: "SR. JANE KAREGI MUNYUGI",
      patients: [
        {
          admissionDate: "2026-04-22",
          odpNo: "IP001",
          fullNames: "John Mwenda",
          age: 45,
          sex: "M",
          subLocation: "Kianjai",
          village: "Kianjai Village",
          address: "P.O Box 123",
          hivStatus: "2",
          hivResult: "Neg",
          nutrition: "3",
          diagnosis: "Severe Malaria",
          treatmentNo: "TX001",
          dischargeDate: "2026-04-25",
          outcome: "A",
          referral: "",
          remarks: "Improved",
        },
        {
          admissionDate: "2026-04-22",
          odpNo: "IP002",
          fullNames: "Mary Wanjiku",
          age: 32,
          sex: "F",
          subLocation: "Mutuati",
          village: "Mutuati Center",
          address: "P.O Box 456",
          hivStatus: "1",
          hivResult: "",
          nutrition: "4",
          diagnosis: "Pneumonia",
          treatmentNo: "TX002",
          dischargeDate: "2026-04-28",
          outcome: "A",
          referral: "",
          remarks: "On antibiotics",
        },
        {
          admissionDate: "2026-04-21",
          odpNo: "IP003",
          fullNames: "Peter Kimathi",
          age: 28,
          sex: "M",
          subLocation: "Kangeta",
          village: "Kangeta",
          address: "P.O Box 789",
          hivStatus: "2",
          hivResult: "Neg",
          nutrition: "3",
          diagnosis: "Typhoid",
          treatmentNo: "TX003",
          dischargeDate: "2026-04-24",
          outcome: "A",
          referral: "",
          remarks: "Fever reduced",
        },
        {
          admissionDate: "2026-04-20",
          odpNo: "IP004",
          fullNames: "Grace Muthoni",
          age: 54,
          sex: "F",
          subLocation: "Laare",
          village: "Laare",
          address: "P.O Box 321",
          hivStatus: "2",
          hivResult: "Pos",
          nutrition: "4",
          diagnosis: "Hypertension",
          treatmentNo: "TX004",
          dischargeDate: "",
          outcome: "",
          referral: "",
          remarks: "Still admitted",
        },
        {
          admissionDate: "2026-04-19",
          odpNo: "IP005",
          fullNames: "James Mwirigi",
          age: 67,
          sex: "M",
          subLocation: "Kianjai",
          village: "Nkinyumu",
          address: "P.O Box 654",
          hivStatus: "1",
          hivResult: "",
          nutrition: "3",
          diagnosis: "Diabetes Type 2",
          treatmentNo: "TX005",
          dischargeDate: "2026-04-22",
          outcome: "D",
          referral: "Meru Level 5",
          remarks: "Referred before death",
        },
      ],
    };
  },
  computed: {
    formattedDateFrom() {
      return this.dateFrom
        ? new Date(this.dateFrom).toLocaleDateString("en-GB")
        : "Start";
    },
    formattedDateTo() {
      return this.dateTo
        ? new Date(this.dateTo).toLocaleDateString("en-GB")
        : "End";
    },
    filteredPatients() {
      let filtered = this.patients;

      if (this.dateFrom) {
        filtered = filtered.filter((p) => p.admissionDate >= this.dateFrom);
      }
      if (this.dateTo) {
        filtered = filtered.filter((p) => p.admissionDate <= this.dateTo);
      }

      return filtered;
    },
    newPatientsMale() {
      return this.filteredPatients.filter(
        (p) => p.sex === "M" && !p.isReAttendant,
      ).length;
    },
    newPatientsFemale() {
      return this.filteredPatients.filter(
        (p) => p.sex === "F" && !p.isReAttendant,
      ).length;
    },
    reAttendantsMale() {
      return this.filteredPatients.filter(
        (p) => p.sex === "M" && p.isReAttendant,
      ).length;
    },
    reAttendantsFemale() {
      return this.filteredPatients.filter(
        (p) => p.sex === "F" && p.isReAttendant,
      ).length;
    },
  },
  methods: {
    clearDates() {
      this.dateFrom = "";
      this.dateTo = "";
    },
    filterPatients() {
      // Computed property handles filtering
    },
    printPage() {
      window.print();
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.register-container {
  background: white;
  min-height: 100vh;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

/* Header */
.header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1a56db;
}

.facility-name {
  font-size: 20px;
  font-weight: bold;
  color: #1a56db;
  margin-bottom: 6px;
}

.facility-details {
  font-size: 11px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 10px;
}

.register-title {
  font-size: 14px;
  font-weight: bold;
  background: #f3f4f6;
  display: inline-block;
  padding: 5px 16px;
  border-radius: 20px;
  color: #1f2937;
}

/* Info Bar */
.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.info-left {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.date-range {
  display: flex;
  gap: 12px;
  align-items: center;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.info-value {
  font-size: 12px;
  color: #1f2937;
  font-weight: 500;
}

.date-input {
  padding: 5px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
}

.btn-clear {
  padding: 5px 12px;
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
}

.btn-clear:hover {
  background: #4b5563;
}

.btn-print {
  padding: 8px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-print:hover {
  background: #2563eb;
}

/* Print Date Range */
.print-date-range {
  text-align: center;
  padding: 8px;
  margin-bottom: 16px;
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  font-size: 12px;
  color: #92400e;
  border-radius: 6px;
}

/* Summary Counts */
.summary-counts {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: center;
}

.count-card {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 10px;
  padding: 10px 20px;
  text-align: center;
}

.count-label {
  font-size: 12px;
  font-weight: 600;
  color: #166534;
  display: block;
  margin-bottom: 6px;
}

.count-values {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.count-item {
  font-size: 12px;
  color: #374151;
}

.count-item strong {
  color: #059669;
  font-size: 14px;
}

/* Table Wrapper */
.table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  max-height: 65vh;
  overflow-y: auto;
}

.register-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  min-width: 1400px;
}

.register-table th {
  background: #1f2937;
  color: white;
  padding: 8px 6px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #374151;
  position: sticky;
  top: 0;
  z-index: 10;
}

.register-table th.sub-header {
  background: #374151;
  font-size: 10px;
}

.register-table td {
  border: 1px solid #d1d5db;
  padding: 6px 4px;
  text-align: left;
}

.register-table td.text-center {
  text-align: center;
}

.empty-row {
  text-align: center;
  padding: 30px;
  color: #6b7280;
}

.outcome-alive {
  color: #059669;
  font-weight: bold;
}

.outcome-dead {
  color: #dc2626;
  font-weight: bold;
}

/* Print Styles */
@media print {
  @page {
    size: landscape;
    margin: 0.3cm;
  }

  .btn-print,
  .btn-clear,
  .date-input {
    display: none;
  }

  .info-bar {
    display: none;
  }

  .print-date-range {
    background: #fef3c7;
    margin: 10px 0;
    padding: 5px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .summary-counts {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .register-container {
    padding: 0.2cm;
  }

  .header {
    margin-bottom: 5px;
  }

  .facility-name {
    font-size: 14px;
  }

  .facility-details {
    font-size: 8px;
  }

  .register-title {
    font-size: 10px;
  }

  .table-wrapper {
    overflow: visible !important;
    max-height: none;
  }

  .register-table {
    font-size: 8px;
    min-width: 0 !important;
  }

  .register-table th {
    padding: 3px 2px;
    font-size: 8px;
    background: #e5e7eb !important;
    color: black !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .register-table td {
    padding: 3px 2px;
    font-size: 7.5px;
  }
}
</style>
